import { render } from "./converter.vue?vue&type=template&id=5f4bc90c"
import script from "./converter.vue?vue&type=script&lang=js"
export * from "./converter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__